/**
 * Catalog of every acknowledgment message key used in the SMB dashboard.
 *
 * Adding a new ack:
 *   1. Add a `kebab-case` key here.
 *   2. Mount `<AcknowledgmentModal messageKey={MESSAGE_KEYS.yourKey} ... />`
 *      somewhere inside `AcknowledgmentsProvider`.
 *
 * Keys are persisted to `user_uw_acknowledgments_v1.message_key` on the
 * server — renaming a key resets the ack for every user, so prefer adding a
 * new key over renaming an old one.
 */
export const MESSAGE_KEYS = {
  orientation: "smb-dashboard-orientation",
  quickbooksConnected: "quickbooks-connected",
  negotiateReviewedComps: "negotiate-reviewed-comps",
  ttwComposerTour: "ttw-composer-tour",
} as const;

export type MessageKey = (typeof MESSAGE_KEYS)[keyof typeof MESSAGE_KEYS];
